import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This interactive element shows the airborne and structural borne sound sources  regarding the dominant perceived sound in receiving room.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          items: [
            { name: "Airborne sound sources" },
            { name: "Structural-borne sound sources" },
            { name: "Structural-borne sound sources-vertical situation" },
          ],
          options: {
            label: "Type of sources",
            labelPosition: "left",
          },
        },
      ],
      extraContent: [[], [], []],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/airborne-sound-sources.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/structural-borne-sound-sources.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/structural-borne-sound-sources-vertical-situation.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
